import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PromptSetApiService } from '../../shared/api.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'delete-confirm-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule, CommonModule],
    templateUrl: './delete-confirm-dialog.component.html',
    styleUrl: './delete-confirm-dialog.component.scss'
})
export class DeleteConfirmDialogComponent {
    isSubmitting = false;
    constructor(public dialogRef: MatDialogRef<DeleteConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private promptSetApiService: PromptSetApiService) { }

    deleteContractCheck() {
        this.isSubmitting = true;
        this.promptSetApiService.deletePromptSet(this.data.prompt_set_id).subscribe((response: any) => {
            this.isSubmitting = false;
            this.dialogRef.close(true);
        });
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
